import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const VerticalBarChart = ({ data, title }) => {

  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');
    const chart = new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
        indexAxis: 'x', // Display bars horizontally
        scales: {
          y: {
            position: 'right',
            beginAtZero: true // Start y-axis at zero
          }
        },
      //   plugins: {
      //       title: {
      //         display: true,
      //         text: title,
      //         position: 'bottom',
      //         padding: {
      //           top: 10,
      //           bottom: 50
      //         }
      //       }
      // }
    }
    });

    // Cleanup on unmount
    return () => {
      chart.destroy();
    };
  }, [data, ]);

  return (
    <div style={{ height: '400px', width: '600px' }}>
      <canvas ref={chartRef} />
    </div>
  );
};

export default VerticalBarChart;
